import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../_metronic/helpers'
import { MyPolicy, OnityPolicyData } from '../../auth/core/_models'
import { PaltechbaseEnrollmentForm } from './PaltechbaseEnrollmentForm'

type Props = {
  show: boolean
  handleClose: () => void
  Title: string
  Email: string | undefined
  CrmUrl: string | undefined
  MyPolicy: MyPolicy | null
}

export const PaltechbaseEnrollmentListModel: React.FC<Props> = ({ show, handleClose, Title, Email, CrmUrl, MyPolicy }) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [policyData, setPolicyData] = useState<OnityPolicyData[] | null>(null)

  useEffect(() => {
    const fetchPolicyData = async () => {
      setLoading(true)
      setError(null)
      try {
        const response = await fetch('https://etl.futurisk.in/webhook/23159409-2334-412d-aacc-1dcc87dfb325', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            Email: Email,
            CorporateCode: MyPolicy?.Policy.CrmDbName,
          }),
        })
        if (!response.ok) {
          throw new Error('Failed to fetch family details')
        }
        const responseData = await response.json()
        const data: OnityPolicyData[] = Array.isArray(responseData) ? responseData : [responseData]
        setPolicyData(data)
      } catch (err: any) {
        setError(err.message || 'An unexpected error occurred')
      } finally {
        setLoading(false)
      }
    }

    if (show) {
      fetchPolicyData()
    }
  }, [show, Email, MyPolicy])

  const dissmissLocation = () => {
    handleClose()
  }

  return (
    <Modal
      className='modal fade'
      id='kt_modal_test'
      data-backdrop='static'
      tabIndex={-1}
      role='model'
      show={show}
      dialogClassName='modal-xl modal-dialog-scrollable'
      aria-hidden='true'
      onHide={dissmissLocation}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>
            {((policyData?.[0] as any)?.Freeze === false || policyData?.[0]?.freezeEnrolment === false) ? 'Enroll Family' : Title}
          </h5>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={dissmissLocation}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {loading ? (
            <div className='text-center'>
              <div className='spinner-border text-primary' role='status'>
                <span className='sr-only'>Loading...</span>
              </div>
            </div>
          ) : error ? (
            <div className='text-danger text-center'>{error}</div>
          ) : ((policyData?.[0] as any)?.Freeze === false || policyData?.[0]?.freezeEnrolment === false) ? (
            <PaltechbaseEnrollmentForm 
              policyData={{...policyData![0], Email: policyData![0].Email || Email || ''}} 
              policyEffectiveDate={MyPolicy?.Policy.PolicyEffectiveDate}
              initialDependents={policyData as any}
              onSuccess={() => handleClose()} 
            />
          ) : (
            // Frozen/Submitted state - Render form in read-only mode using first element as base
            // Map the enrollment record fields to OnityPolicyData where possible
            <PaltechbaseEnrollmentForm 
              policyData={{
                ...policyData?.[0], 
                Grade: policyData?.[0]?.Grade || '',
                freezeEnrolment: true,
                Email: Email || '', // Email might not be in the enrollment record
              } as any}
              policyEffectiveDate={MyPolicy?.Policy.PolicyEffectiveDate}
              preloadedMembers={policyData as any}
              onSuccess={() => handleClose()}
            />
          )}
        </div>
      </div>
    </Modal>
  )
}
